import gql from 'graphql-tag'

export const SEARCH_EXACT_PATH = gql`
    query searchExactSearch($searchTerm: String!) {
        searchExactPath(searchTerm: $searchTerm)
    }
`
